// extracted by mini-css-extract-plugin
export default {"SettingsModule":"settings_SettingsModule__n0sUH"};